import * as THREE from "three"
import {PointerLockControls} from 'three/examples/jsm/controls/PointerLockControls.js';
import {DefaultDeviceHandler} from "./default_device_handler";

export class Three3DHandler extends DefaultDeviceHandler {
    moveForward = false;
    moveBackward = false;
    moveLeft = false;
    moveRight = false;
    canJump = true;

    cameraOffset = new THREE.Vector3(0, 2.7, 0);

    speed = 200;

    sendTimer = 180;
    lastSendTime = 0;

    velocity = new THREE.Vector3();
    direction = new THREE.Vector3();

    lastVelocity = new THREE.Vector3();
    lastDirection = new THREE.Vector3();

    constructor() {
        super();
        this.setupListeners();
    }

    setupListeners() {
        document.addEventListener('keydown', (e) => this.onKeyDown(e));
        document.addEventListener('keyup', (e) => this.onKeyUp(e));
    }

    animate(delta, onChange) {
        this.lastVelocity = this.velocity.clone();
        this.lastDirection = this.direction.clone();

        if (this.player !== null)
            this.deviceControls.getObject().position.copy(this.player.obj.position.clone().add(this.cameraOffset));

        if (this.deviceControls.isLocked === true) {
            this.onMoving(delta, onChange)
        }
    }

    onMoving(delta, onChange) {
        if (this.player === null)
            return

        const obj = this.player.obj;

        this.direction.z = Number(this.moveForward) - Number(this.moveBackward);
        this.direction.x = Number(this.moveRight) - Number(this.moveLeft);
        this.direction.normalize(); // this ensures consistent movements in all directions

        if (this.moveForward || this.moveBackward) this.velocity.z -= this.direction.z * this.speed * delta;
        if (this.moveLeft || this.moveRight) this.velocity.x -= this.direction.x * this.speed * delta;

        // const npos = new THREE.Vector3(0, 0, 0).copy(obj.position)

        // this.deviceControls.moveRight(-this.velocity.x * delta);
        // this.deviceControls.moveForward(-this.velocity.z * delta);
        // npos.x += this.direction.x * 5
        // npos.z -= this.direction.z * 5
        // npos.y += this.direction.y * 5

        const distance = 5;
        // const npos = this.camera.position.clone().add(this.direction.multiplyScalar(distance));

        const npos = new THREE.Vector3(0, 0, 0)
        this.camera.getWorldDirection(npos)
        // npos.z -= 15
        // npos.y = obj.position.y
        // const theta = Math.atan2(npos.x, npos.z);

        const startPos = this.camera.position;
        startPos.y = obj.position.y

        const newPos = new THREE.Vector3();
        newPos.addVectors ( startPos, npos.multiplyScalar( distance ) );


        if (this.lastSendTime + this.sendTimer < performance.now()) {
            console.log("onChange", {
                direction: this.direction,
                pos: newPos,
                rot: obj.rotation
            })

            this.lastSendTime = performance.now();
            onChange(newPos, obj.rotation.clone());
        }


        // const nlv = this.lastVelocity.clone().normalize();
        // const nld = this.lastDirection.clone().normalize()
        // if (!nlv.equals(this.velocity.clone().normalize()) || !nld.equals(this.direction.clone().normalize())) {
        //
        //     // onChange(, this.player.rotation)
        //     console.log("onChange", {
        //         pos: npos,
        //         rot: obj.rotation
        //     })
        //     onChange(npos, obj.rotation.clone());
        // }
    }

    bindControls(camera, domElement, scene) {
        this.camera = camera;
        this.camera.position.set(0, 2, 0)
        this.deviceControls = new PointerLockControls(camera, domElement);
        this.deviceControls.lock();

        document.getElementById("menu-start").addEventListener('click', () => {
            console.log("Locking controls")
            setTimeout(() => {
                this.deviceControls.lock();
            }, 60);
        });

        this.deviceControls.addEventListener('lock', () => {
            console.log("controls", 'lock')
            document.getElementById("blocker").style.display = "none";
        });

        this.deviceControls.addEventListener('unlock', () => {
            console.log("controls", 'unlock')
            document.getElementById("blocker").style.display = "block";
        });

        return this.deviceControls;
    }

    setPlayer(ent) {
        super.setPlayer(ent);
        this.camera.position.set(0, 2 * ent.scale.y, 0)
        console.log("Device3D:setPlayer", {
            ent: ent,
            dc: this.deviceControls.getObject()
        })
    }


    onKeyDown(event) {
        switch (event.code) {
            case 'ArrowUp':
            case 'KeyW':
                this.moveForward = true;
                break;
            case 'ArrowLeft':
            case 'KeyA':
                this.moveLeft = true;
                break;
            case 'ArrowDown':
            case 'KeyS':
                this.moveBackward = true;
                break;
            case 'ArrowRight':
            case 'KeyD':
                this.moveRight = true;
                break;
        }
    };

    onKeyUp(event) {
        switch (event.code) {
            case 'ArrowUp':
            case 'KeyW':
                this.moveForward = false;
                break;

            case 'ArrowLeft':
            case 'KeyA':
                this.moveLeft = false;
                break;

            case 'ArrowDown':
            case 'KeyS':
                this.moveBackward = false;
                break;

            case 'ArrowRight':
            case 'KeyD':
                this.moveRight = false;
                break;

            case 'Space':
                // if (this.canJump === true)  {
                // 	console.log("Jumping")
                // 	this.velocity.y = 100;
                // };
                // this.canJump = false;
                break;
        }
    };

    getPosition() {
        if (this.camera === null)
            return null;

        return this.camera.position.clone()
    }

    getRotation() {
        if (this.camera === null)
            return 0;

        return this.camera.rotation.clone()
    }

    //TODO
    getAngle() {
        // return this.deviceControls.getDirection()
        return 0;
    }
}